import { DefaultError, useMutation } from "@tanstack/react-query";
import { invalidateEntireModuleListQuery } from "entities/modules/queries/useModuleListByTagIdQuery";
import { movePageModule } from "../api/movePageModule";
import { invalidateModuleListByBrandPageQuery } from "../queries/useModuleListByBrandPageQuery";
import { PageModuleData } from "../types";

type Params = {
  module: PageModuleData;
  sourceBrandId: string;
  sourcePageId: string;
  targetBrandId: string;
  targetPageId: string;
};

export const useMovePageModuleMutation = () => {
  const mutation = useMutation<void, DefaultError, Params>({
    mutationFn: async (params) => {
      await movePageModule({
        module: params.module,
        sourceBrandId: params.sourceBrandId,
        sourcePageId: params.sourcePageId,
        targetBrandId: params.targetBrandId,
        targetPageId: params.targetPageId,
      });
    },
    onSuccess: (_, params) => {
      invalidateModuleListByBrandPageQuery(
        params.sourceBrandId,
        params.sourcePageId,
      );

      invalidateModuleListByBrandPageQuery(
        params.targetBrandId,
        params.targetPageId,
      );

      invalidateEntireModuleListQuery();
    },
  });

  return {
    ...mutation,
  };
};
